import React from 'react'
import Layout from '../components/layout'
import { useCurrentDoc } from 'docz'
import Seo from '../components/seo'

export default ({ children }) => {
  const content = <article>{children}</article>
  const doc = useCurrentDoc()

  return (
    <Layout current='docs'>
      <Seo title={doc.name} />
      {content}
    </Layout>
  )
}
